export default class EvtSectionTitleChanged {
    constructor(
        // eslint-disable-line no-useless-constructor
        public sectionId: number,
        public newTitle: string
    ) {}
}
